import CreateConfiguration from "../../Components/OperatorManagement/CreateConfiguration"

export default function CreateConfigurations(){
    return(
        <CreateConfiguration/>
    )
}